import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useLogout } from "@/hooks/use-logout";
import { useNavigate } from "react-router-dom";

type NoMembershipScreenProps = {
  showOnboardingCta?: boolean;
};

export function NoMembershipScreen({
  showOnboardingCta = false,
}: NoMembershipScreenProps) {
  const { t } = useTranslation("common");
  const logout = useLogout();
  const navigate = useNavigate();

  const handleSignOut = () => {
    logout();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full p-8 space-y-4 text-center">
        <h1 className="text-xl font-semibold">{t("auth.noMembershipTitle")}</h1>
        <p className="text-sm text-muted-foreground">
          {t("auth.noMembershipBody")}
        </p>
        {showOnboardingCta ? (
          <Button
            type="button"
            className="w-full"
            onClick={() => navigate("/admin/onboarding", { replace: true })}
          >
            {t("auth.startOnboarding")}
          </Button>
        ) : null}
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={handleSignOut}
        >
          {t("auth.backToLogin")}
        </Button>
      </Card>
    </div>
  );
}
